// extracted by mini-css-extract-plugin
export default {"touch_component":"PreviewPdfFileComponent_touch_component__7LmAe"};